import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MuxDemux, MuxModel, MuxRemoveResponse } from "@nms-ng2/app/modules/topology/mux/mux-demux.model";
import { Observable } from "rxjs";

/**
 * Classe responsável por realizar as requisições disponibilizadas pelo serviço de inventory para Mux/Demux.
 */
@Injectable({
    providedIn: "root"
})
export class MuxRestService {
    private readonly baseUrl: string;
    private readonly bffBaseUrl: string;
    private readonly CONTENT_TYPE_APPLICATION_JSON = "application/json";

    constructor(private readonly http: HttpClient) {
        this.baseUrl = "/mux";
        this.bffBaseUrl = "/web/topology/mux";
    }

    public saveMuxDemux(muxDemux: MuxDemux): Observable<MuxDemux> {
        const httpOptions = { headers: new HttpHeaders({ "Content-Type": this.CONTENT_TYPE_APPLICATION_JSON }) };
        return this.http.post<MuxDemux>(`${this.baseUrl}`, muxDemux, httpOptions);
    }

    public updateMuxDemux(muxDemux: MuxDemux): Observable<MuxDemux> {
        const httpOptions = {
            headers: new HttpHeaders({ "Content-Type": this.CONTENT_TYPE_APPLICATION_JSON })
        };
        return this.http.put<MuxDemux>(`${this.bffBaseUrl}`, muxDemux, httpOptions);
    }

    public removeMuxDemux(muxDemux: MuxDemux[]): Observable<MuxRemoveResponse> {
        const muxIds: number[] = muxDemux.map((mux) => mux.resourceId);
        const httpOptions = { headers: new HttpHeaders({ "Content-Type": this.CONTENT_TYPE_APPLICATION_JSON }), body: muxIds };

        return this.http.delete<MuxRemoveResponse>(`${this.bffBaseUrl}`, httpOptions);
    }

    public getMuxModels(): Observable<Array<MuxModel>> {
        return this.http.get<Array<MuxModel>>(`${this.baseUrl}/models`);
    }

    public getMux(resourceId: number): Observable<MuxDemux> {
        return this.http.get<MuxDemux>(`${this.bffBaseUrl}/${resourceId}`);
    }
}
